import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { setupNotifications } from './firebase';
import { toastNotification, sendNativeNotification } from './notificationHelpers';
import useVisibilityChange from './useVisibilityChange';
import 'react-toastify/dist/ReactToastify.css';
import ScrollToTop from './utils/ScrollToTop';
import AuthVersionGuard from './utils/AuthVersionGuard';
import PageNotFound from './pages/PageNotFound';
import ClinicLayout from './layout/ClinicLayout';
import Signin from './pages/Signin';
import Invoice from './pages/invoice/Invoice';
import MachineDetails from './pages/machines/MachineDetails';
import AccountSettings from './pages/AccountSettings';
import HudPatients from './pages/HUD/patients/hud_patients';
import AddInvoice from './pages/invoice/add_invoice';
import ConsultationInvoice from './pages/consultation/consultation_Invoice';
import AddConsultationInvoice from './pages/consultation/add_consultation_invoice';
import Medicines from './pages/medicines/medicines';
import { getUserRole } from './utils/localStoarege';
import CenterMedicines from './pages/center_medicines/center_medicines';
import AddCenterMedicine from './pages/center_medicines/add_center_medicine';
import AddMedicine from './pages/medicines/add_medicine';
import MedicinePurchaseHistory from './pages/medicines/medicines_purchase_history';
import MedicineIssueHistory from './pages/medicines/medicines_issue_history';
import IssuedMedicines from './pages/issued_medicines/IssuedMedicines';
import MedicineInvoice from './pages/medicine_invoice/medicine_Invoice';
import AddMedicineInvoice from './pages/medicine_invoice/add_medicine_invoice';
import DeveloperViewMain from './pages/developer_view/DeveloperViewMain';
import Dashboard from './pages/Dashboard';
import OldMachineDetails from './pages/old_machines/OldMachineDetails';
import HudHome from './pages/HUD/HudHome';
import HudLayout from './layout/HudLayout';
import HudMachines from './pages/HUD/machines/hud_machines';
import HudMedicines from './pages/HUD/medicines/hud_medicines';
import PatientForm from './pages/HUD/patients/patient_form';
import PatientHistory from './pages/HUD/patients/patient_history';
import PatientFiles from './pages/HUD/patients/patient_files';
import PatientPackages from './pages/HUD/patients/patient_packages';
import PatientDoses from './pages/HUD/patients/patient_doses';
import DoctorLayout from './layout/DoctorLayout';
import AddPatientPackageInvoice from './pages/HUD/patients/add_patient_packge_invoice';
import DoctorHome from './pages/DoctorView/DoctorHome';
import Finances from './pages/DoctorView/Finances';
import AllCentersTpt from './pages/DoctorView/AllCentersTpt';
import DoctorView from './pages/DoctorView/doctor_view';
import DoctorInvoice from './pages/DoctorView/doctor_Invoice';
import AccountLayout from './layout/AccountLayout';
import AccountDownloadExcel from './pages/Account/AccountDownloadExcel';
import AccountPackageInvoice from './pages/Account/AccountPackageInvoice';
import AccountConsultationInvoice from './pages/Account/account_consultation_Invoice';
import AccountMedicineInvoice from './pages/Account/AccountMedicinesInvoice';
import AccountIssuedMedicineInvoice from './pages/Account/AccountIssuedMedicinesInvoice';
import AccountHudInvoice from './pages/Account/AccountHudInvoice';
import AccountHome from './pages/Account/AccountHome';
import NewHudPatients from './pages/New_Clinic_Dashboard/patients/new_hud_patients';
import NewPatientForm from './pages/New_Clinic_Dashboard/patients/new_patient_form';
import NewPatientHistory from './pages/New_Clinic_Dashboard/patients/new_patient_history';
import NewPatientFiles from './pages/New_Clinic_Dashboard/patients/new_patient_files';
import NewPatientPackages from './pages/New_Clinic_Dashboard/patients/new_patient_packages';
import NewPatientDoses from './pages/New_Clinic_Dashboard/patients/new_patient_doses';
import NewAddPatientPackageInvoice from './pages/New_Clinic_Dashboard/patients/new_add_patient_packge_invoice';
import ClinicDoctorView from './pages/New_Clinic_Dashboard/Doctor/clinic_doctor_view';
import NewPatientApproval from './pages/New_Clinic_Dashboard/patients/new_patient_approval';
import VideoCall from './pages/VideoCall';
import PackageFilteredTable from './pages/New_Clinic_Dashboard/patients/package_filtered_table';
import EnquiryForClinic from './pages/EnquiryForClinic';
import EnquiryForClinicView from './pages/EnquiryForClinicView';
import MedicalLayout from './layout/MedicalLayout';

function App() {
  const isForeground = useVisibilityChange();
  useEffect(() => {
    setupNotifications((message) => {
      if (isForeground) {
        toastNotification({
          message,
          description: message,
          status: "info",
        });
      } else {
        sendNativeNotification({
          message,
          message,
        });
      }
    });
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <AuthVersionGuard />
      <div className='w-full'>
        <Routes>
          <Route
            exact
            path="/"
            element={
              <ClinicLayout noSidebar>
                <Signin />
              </ClinicLayout>
            }
          />
          <Route
            exact
            path="/:role"
            element={
              <ClinicLayout noSidebar>
                <Signin />
              </ClinicLayout>
            }
          />

          {/* CLINIC SCREENS START */}

          {getUserRole() !== "operator" ? <Route
            exact
            path="/dashboard"
            element={
              <ClinicLayout>
                <Dashboard />
              </ClinicLayout>
            }
          /> : <></>}
          {getUserRole() === "admin" ? <Route
            exact
            path="/tpt-machines"
            element={
              <ClinicLayout>
                <AllCentersTpt />
              </ClinicLayout>
            }
          /> : <></>}
          <Route
            exact
            path="/package-invoice"
            element={
              <ClinicLayout>
                <Invoice />
              </ClinicLayout>
            }
          />
          <Route
            exact
            path="/package-invoice/add"
            element={
              <ClinicLayout>
                <AddInvoice />
              </ClinicLayout>
            }
          />
          <Route
            exact
            path="/consultation-invoice"
            element={
              <ClinicLayout>
                <ConsultationInvoice />
              </ClinicLayout>
            }
          />
          <Route
            exact
            path="/consultation-invoice/add"
            element={
              <ClinicLayout>
                <AddConsultationInvoice />
              </ClinicLayout>
            }
          />
          <Route
            exact
            path="/invoice-medicine"
            element={
              <ClinicLayout>
                <MedicineInvoice />
              </ClinicLayout>
            }
          />
          <Route
            exact
            path="/invoice-medicine/add"
            element={
              <ClinicLayout>
                <AddMedicineInvoice />
              </ClinicLayout>
            }
          />
          <Route
            exact
            path="/medicine"
            element={
              <ClinicLayout>
                {getUserRole() === "operator" ? <CenterMedicines /> : <Medicines />}
              </ClinicLayout>
            }
          />
          {
            getUserRole() === "operator" ? <></> : <Route
              exact
              path="/medicine/history"
              element={
                <ClinicLayout>
                  <MedicinePurchaseHistory />
                </ClinicLayout>
              }
            />
          }
          {
            getUserRole() === "operator" ? <></> : <Route
              exact
              path="/medicine/issue/history"
              element={
                <ClinicLayout>
                  <MedicineIssueHistory />
                </ClinicLayout>
              }
            />
          }
          <Route
            exact
            path="/center-medicine"
            element={
              <ClinicLayout>
                <CenterMedicines />
              </ClinicLayout>
            }
          />
          {
            getUserRole() !== "operator" ? <Route
              exact
              path="/issued-medicines"
              element={
                <ClinicLayout>
                  <IssuedMedicines />
                </ClinicLayout>
              }
            /> : <></>
          }
          <Route
            exact
            path="/medicine/add"
            element={
              <ClinicLayout>
                {getUserRole() === "operator" ? <AddCenterMedicine /> : <AddMedicine />}
              </ClinicLayout>
            }
          />
          <Route
            exact
            path="/center-medicine/add"
            element={
              <ClinicLayout>
                {getUserRole() === "operator" ? <AddCenterMedicine /> : <AddMedicine />}
              </ClinicLayout>
            }
          />
          <Route path="/machine/:slug/"
            element={
              <ClinicLayout>
                <MachineDetails />
              </ClinicLayout>}
          />
          <Route path="/old-machine/:slug/"
            element={
              <ClinicLayout>
                <OldMachineDetails />
              </ClinicLayout>}
          />
          <Route
            exact
            path="/account"
            element={
              <ClinicLayout>
                <AccountSettings />
              </ClinicLayout>
            }
          />
          <Route
            exact
            path="/enquiry"
            element={
              getUserRole() === "operator" ?
                <ClinicLayout>
                  <EnquiryForClinicView />
                </ClinicLayout> :
                <DoctorLayout>
                  <EnquiryForClinicView forDoctor={true} />
                </DoctorLayout>
            }
          />
          <Route
            exact
            path="/enquiry/add"
            element={
              getUserRole() === "operator" ?
                <ClinicLayout>
                  <EnquiryForClinic />
                </ClinicLayout> :
                <DoctorLayout>
                  <EnquiryForClinic />
                </DoctorLayout>

            }
          />
          {
            getUserRole() === "developer" ?
              <Route
                exact
                path="/developer"
                element={
                  <ClinicLayout>
                    <DeveloperViewMain />
                  </ClinicLayout>
                }
              /> : <></>}

          {/* CLINIC SCREENS END */}

          {/* NEW CLINIC DASHBOARD SCREENS START */}
          <Route
            exact
            path="/new-hud-patients"
            element={
              <ClinicLayout>
                <NewHudPatients />
              </ClinicLayout>
            }
          />
          <Route
            exact
            path="/new-hud-filtered-patients"
            element={
              getUserRole() === "operator" ?
                <ClinicLayout>
                  <PackageFilteredTable />
                </ClinicLayout>
                : <DoctorLayout>
                  <PackageFilteredTable />
                </DoctorLayout>
            }
          />
          <Route path="/new-hud-patients/:slug/"
            element={
              <ClinicLayout>
                <NewPatientForm />
              </ClinicLayout>}
          />
          <Route path="/new-hud-patients/packages/add-invoice"
            element={
              <ClinicLayout>
                <NewAddPatientPackageInvoice />
              </ClinicLayout>}
          />
          <Route path="/new-hud-patients/packages/approvals"
            element={
              <ClinicLayout>
                <NewPatientApproval />
              </ClinicLayout>}
          />
          <Route path="/new-hud-patients/history/"
            element={
              <ClinicLayout>
                <NewPatientHistory />
              </ClinicLayout>}
          />
          <Route path="/new-hud-patients/files/"
            element={
              <ClinicLayout>
                <NewPatientFiles />
              </ClinicLayout>}
          />
          <Route path="/new-hud-patients/packages/"
            element={
              <ClinicLayout>
                <NewPatientPackages />
              </ClinicLayout>}
          />
          <Route path="/new-hud-patients/package/doses/"
            element={
              <ClinicLayout>
                <NewPatientDoses />
              </ClinicLayout>}
          />
          <Route path="/clinic/doctor-view"
            element={
              <ClinicLayout>
                <ClinicDoctorView />
              </ClinicLayout>}
          />
          {/* NEW CLINIC DASHBOARD SCREENS START */}

          {/* HUD SCREENS START */}

          <Route
            exact
            path="/home"
            element={
              <HudLayout>
                <HudHome />
              </HudLayout>
            }
          />
          <Route
            exact
            path="/hud-machines"
            element={
              <HudLayout>
                <HudMachines />
              </HudLayout>
            }
          />
          <Route
            exact
            path="/hud-medicines"
            element={
              <HudLayout>
                <HudMedicines />
              </HudLayout>
            }
          />
          <Route
            exact
            path="/hud-patients"
            element={
              <HudLayout>
                <HudPatients />
              </HudLayout>
            }
          />
          <Route
            exact
            path="/hud-doctor-view"
            element={
              <HudLayout>
                <DoctorView />
              </HudLayout>
            }
          />
          <Route path="/hud-patients/:slug/"
            element={
              <HudLayout>
                <PatientForm />
              </HudLayout>}
          />
          <Route path="/hud-patients/packages/add-invoice"
            element={
              <HudLayout>
                <AddPatientPackageInvoice />
              </HudLayout>}
          />
          <Route path="/hud-patients/history/"
            element={
              <HudLayout>
                <PatientHistory />
              </HudLayout>}
          />
          <Route path="/hud-patients/files/"
            element={
              <HudLayout>
                <PatientFiles />
              </HudLayout>}
          />
          <Route path="/hud-patients/packages/"
            element={
              <HudLayout>
                <PatientPackages />
              </HudLayout>}
          />
          <Route path="/hud-patients/package/doses/"
            element={
              <HudLayout>
                <PatientDoses />
              </HudLayout>}
          />

          {/* HUD SCREENS START */}

          {/* DOCTOR SCREENS START */}

          <Route
            exact
            path="/doctor/home"
            element={
              <DoctorLayout>
                <DoctorHome />
              </DoctorLayout>
            }
          />
          <Route
            exact
            path="/doctor"
            element={
              <DoctorLayout>
                <DoctorView />
              </DoctorLayout>
            }
          />
          <Route
            exact
            path="/doctor/finances"
            element={
              <DoctorLayout>
                <Finances />
              </DoctorLayout>
            }
          />
          <Route
            exact
            path="/doctor/:slug"
            element={
              <DoctorLayout>
                <ClinicDoctorView />
              </DoctorLayout>
            }
          />
          <Route
            exact
            path="/doctor/home/invoice"
            element={
              <DoctorLayout>
                <DoctorInvoice />
              </DoctorLayout>
            }
          />

          {/* DOCTOR SCREENS END */}

          <Route
            exact
            path="/video-call"
            element={
              getUserRole() === "operator" ?
                <ClinicLayout>
                  <VideoCall role={getUserRole()} />
                </ClinicLayout>
                : <DoctorLayout>
                  <VideoCall role={getUserRole()} />
                </DoctorLayout>
            }
          />

          {/* ACCOUNT SCREENS START */}

          <Route
            exact
            path="/account/home"
            element={
              <AccountLayout>
                <AccountHome />
              </AccountLayout>
            }
          />
          <Route
            exact
            path="/account/download-excel"
            element={
              <AccountLayout>
                <AccountDownloadExcel />
              </AccountLayout>
            }
          />
          <Route
            exact
            path="/account/package"
            element={
              <AccountLayout>
                <AccountPackageInvoice />
              </AccountLayout>
            }
          />
          <Route
            exact
            path="/account/consultancy"
            element={
              <AccountLayout>
                <AccountConsultationInvoice />
              </AccountLayout>
            }
          />
          <Route
            exact
            path="/account/medicine"
            element={
              <AccountLayout>
                <AccountMedicineInvoice />
              </AccountLayout>
            }
          />
          <Route
            exact
            path="/account/issued-medicine"
            element={
              <AccountLayout>
                <AccountIssuedMedicineInvoice />
              </AccountLayout>
            }
          />
          <Route
            exact
            path="/account/hud/invoices"
            element={
              <AccountLayout>
                <AccountHudInvoice />
              </AccountLayout>
            }
          />

          {/* ACCOUNT SCREENS END */}

          {/* MEDICAL SCREENS START */}

          <Route
            exact
            path="/medical/home"
            element={
              <MedicalLayout>
                <Medicines />
              </MedicalLayout>
            }
          />
          <Route
            exact
            path="/medical/medicines"
            element={
              <MedicalLayout>
                <Medicines />
              </MedicalLayout>
            }
          />
          <Route
            exact
            path="/medical/medicines/add"
            element={
              <MedicalLayout>
                <AddMedicine />
              </MedicalLayout>
            }
          />
          <Route
            exact
            path="/medical/medicines/history"
            element={
              <MedicalLayout>
                <MedicinePurchaseHistory />
              </MedicalLayout>
            }
          />
          <Route
            exact
            path="/medical/medicines/issue/history"
            element={
              <MedicalLayout>
                <MedicineIssueHistory />
              </MedicalLayout>
            }
          />
          <Route
            exact
            path="/medical/invoice-medicine"
            element={
              <MedicalLayout>
                <MedicineInvoice />
              </MedicalLayout>
            }
          />
          <Route
            exact
            path="/medical/invoice-medicine/add"
            element={
              <MedicalLayout>
                <AddMedicineInvoice />
              </MedicalLayout>
            }
          />
          <Route
            exact
            path="/medical/issued-medicines"
            element={
              <MedicalLayout>
                <IssuedMedicines />
              </MedicalLayout>
            }
          />

          {/* MEDICAL SCREENS END */}

          <Route
            exact
            path="*"
            element={
              <ClinicLayout noSidebar={true}>
                <PageNotFound />
              </ClinicLayout>
            }
          />
        </Routes>

        <ToastContainer stacked={true} />
      </div>
    </Router>
  );
}

export default App;
